module.exports = __webpack_public_path__ + "img/Directors.11bf36be.png";